// extracted by mini-css-extract-plugin
module.exports = {"createAccount":"createAccount_createAccount__2UBQk","InputItemContent":"createAccount_InputItemContent__3gw4B"};